var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalLinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3147_1510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C17.061 0 22 4.939 22 11C22 17.061 17.061 22 11 22C4.939 22 0 17.061 0 11C0 4.939 4.939 0 11 0ZM4.345 8.327C4.015 9.152 3.828 10.054 3.828 11C3.828 14.96 7.04 18.172 11 18.172C14.96 18.172 18.172 14.96 18.172 11C18.172 7.04 14.96 3.828 11 3.828C10.241 3.828 9.504 3.949 8.822 4.169C9.812 4.719 10.472 5.764 10.472 6.974C10.472 8.745 9.031 10.186 7.26 10.186C5.973 10.186 4.862 9.427 4.345 8.327Z",
    fill: "#00C8D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3147_1510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinks);
export default __webpack_public_path__ + "static/media/externalLinks.fff78ce439d02eb675fb4af57d25c894.svg";
export { ForwardRef as ReactComponent };